import {format as fnsFormat, parseISO} from "date-fns"
import {isString} from "lodash"

export function format(date: string | Date): string {
  const toFormat = isString(date) ? parseISO(date) : date
  return fnsFormat(toFormat, "dd/MM/yyy")
}

export function formatMonth(date: string | Date): string {
  const toFormat = isString(date) ? parseISO(date) : date
  return fnsFormat(toFormat, "MMM yyyy")
}
